import { useContext } from 'react'
import { KYCContext } from '../KYCContext'

const useKYC = () => useContext(KYCContext)

export default useKYC
